<template>
  <div>  
    <div class="--uppercase">
      {{ $t('tactics.instructions.inPossession.finalThird.finalThird') }}
    </div>
    
    <CheckboxTeamInstruction
      name="work-ball-into-box"
      :value="workBallIntoBox"
      mutation="updateWorkBallIntoBox"
    >
      {{ $t('tactics.instructions.inPossession.finalThird.workBallIntoBox') }}
    </CheckboxTeamInstruction>

    <CheckboxTeamInstruction
      name="shoot-on-sight"
      :value="shootOnSight"
      mutation="updateShootOnSight"
    >
      {{ $t('tactics.instructions.inPossession.finalThird.shootOnSight') }}
    </CheckboxTeamInstruction>

    <CheckboxTeamInstruction
      name="hit-early-crosses"
      :value="hitEarlyCrosses"
      mutation="updateHitEarlyCrosses"
    >
      {{ $t('tactics.instructions.inPossession.finalThird.hitEarlyCrosses') }}
    </CheckboxTeamInstruction>

    <CheckboxTeamInstruction
      name="play-for-set-pieces"
      :value="playForSetPieces"
      mutation="updatePlayForSetPieces"
    >
      {{ $t('tactics.instructions.inPossession.finalThird.playForSetPieces') }}
    </CheckboxTeamInstruction>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CheckboxTeamInstruction from "@/components/CheckboxTeamInstruction";

export default {
  components: {
    CheckboxTeamInstruction
  },

  computed: mapState({
    workBallIntoBox: state => state.instructions.inPossession.finalThird.workBallIntoBox,
    shootOnSight: state => state.instructions.inPossession.finalThird.shootOnSight,
    hitEarlyCrosses: state => state.instructions.inPossession.finalThird.hitEarlyCrosses,
    playForSetPieces: state => state.instructions.inPossession.finalThird.playForSetPieces
  })
}
</script>

<style scoped>

</style>
